export interface AlertProps {
  show: boolean;
  heading: string;
  headingTag?: AlertHeadingTag;
  content?: string;
  type?: AlertType;
  closable: boolean;
  onClose?: () => void;
  className?: string;
}

export enum AlertType {
  Default = 'default',
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
}

// The heading can exist without further information as long as it provide clear context for the user.
export type AlertHeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
